import React, { Fragment, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { slide as Menu } from 'react-burger-menu'


{/* LOGOS EN BLANCO */ }
import LogoMagueySVG from '../../img/logoBlancoSVG2.svg';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import estilos from './MenuHamburguesaInspectorDeCampo.module.css'; { {/*Estilos para el componente*/ } }
import Backdrop from '@mui/material/Backdrop';

import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faCheckDouble, faClock, faCalendar, faWrench,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faPenToSquare, faEdit, faPersonWalking, faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons'
import BotonMenuHamburguesa from './BotonMenuHamburguesa';
import ConfiguracionComponent from '../UsuarioInspector/Configuracion/ConfiguracionComponent';

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faPenToSquare, faCheckDouble, faClock, faPersonWalking, faRightFromBracket,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faCalendar, faWrench)


const MenuHamburguesaInspectorDeCampo = (props) => {

    var styles = {
        bmBurgerButton: {
            position: 'fixed',
            width: '36px',
            height: '30px',
            left: '36px',
            top: '36px'
        },
        bmBurgerBars: {
            background: 'white'
        },
        bmBurgerBarsHover: {
            background: '#a90000'
        },
        bmCrossButton: {
            height: '24px',
            width: '24px'
        },
        bmCross: {
            background: 'white'
        },
        bmMenuWrap: {
            position: 'fixed',
            height: '100%'
        },
        bmMenu: {
            background: '#68813B',
            padding: '2.5em 1.5em 0',
            fontSize: '1.15em'
        },
        bmMorphShape: {
            fill: '#373a47'
        },
        bmItemList: {
            color: 'white',
            padding: '0.8em'
        },
        bmItem: {
            display: 'inline-block'
        },
        bmOverlay: {
            background: 'rgba(0, 0, 0, 0.3)'
        }
    }

    const styleModal = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        overflow: 'scroll',
        height: '50%',
    };


    const myRef = useRef(null)
    const currentUser = useSelector(store => store.Usuario.data)
    const loginIn = localStorage.getItem('user')
    let idUsuario = 0
    if (currentUser) {
        idUsuario = currentUser.user[0].id
    }



    const zonasOpciones = [];
    const solicitudesOpciones = [];
    const inspectoresOpciones = [];
    const agendaOpciones = [];
    const calendarioOpciones = [];
    const trazabilidadOpciones = [];
    const asociadosOpciones = [];
    const fisicoquimicoOpciones = [];
    const inventarioOpciones = [];
    const autorizarEtiquetasOpciones = [];
    const catalogoMagueyOpciones = [];
    const vehiculosOpciones = [];
    const generadorInformesOpciones = [

        { text: 'Instalaciones', ruta: '' },
        { text: 'Granel', ruta: '' },
        { text: 'Nacional', ruta: '' },
        { text: 'Exportación', ruta: '' },

    ];
    const generadorEtiquetasOpciones = [

        { text: 'Granel', ruta: '' },
        { text: 'Laboratorio', ruta: '' },
        { text: 'Maduración', ruta: '' },

    ];
    const generarVisitaOpciones = [];

    const [modalConfig, setModalConfig] = React.useState(false);
    const handleAbrirModalConfig = () => {
        setModalConfig(true);
    }

    const handleCerrarModalConfig = () => {
        setModalConfig(false);
    }
    const HTMLabrirConfiguraciones = () => {
        return (
            <Modal
                open={modalConfig}
                onClose={handleCerrarModalConfig}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModal} >
                    <ConfiguracionComponent></ConfiguracionComponent>
                </Box>

            </Modal>
        )
    }




    return (
        <Fragment>
            <div className={`${estilos.header}`}>
                <Fragment>
                    <header className='row text-center'>
                        <div className='col-10'>
                            <div className='row'>
                                <div className='col-4'>
                                    <div className='row'>
                                        <div className='col-6' style={{ textAlign: 'right' }}>

                                        </div>
                                        <div className='col-6'>
                                            <img src={LogoMagueySVG} width={80}></img>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6 mt-2' style={{ textAlign: 'center', fontSize: '10px !important' }}>
                                    <span className='textoEscondido text-center text-light'><strong>Unidad de Inspección</strong><br />Panel de Inspector en Campo</span>
                                </div>
                            </div>

                        </div>
                        <div className='col-2 mt-3' style={{ textAlign: 'right', paddingRight: '4%' }}>
                            <Tooltip title="Salir de la aplicación" arrow>
                                <button style={{ border: 'none', padding: '4px', backgroundColor: '#68813B', color: 'white', fontFamily: 'Montserrat', boxShadow: 'none', textDecoration: 'none' }} onClick={props.cerrarSesionModal} className="text-wrap text-center botonZoom"> <FontAwesomeIcon style={{ transform: 'scale(1.5)' }} icon={faRightFromBracket} /><br />Salir</button>
                            </Tooltip>

                        </div>

                    </header>
                </Fragment>
            </div>

            <Menu styles={styles}>
                <List className={`${estilos.lista}`}>
                    {
                        props.idUsuario === 4 ?
                            (
                                <Fragment>
                                    <BotonMenuHamburguesa titulo="Clientes" objeto={asociadosOpciones} ruta="/PanelAsociados"></BotonMenuHamburguesa>
                                </Fragment>
                            ) :

                            (
                                <></>
                            )
                    }
                </List>
            </Menu>

            <br /><br /><br /><br />
            {props.componenteCerrarSesionModal}
            {HTMLabrirConfiguraciones()}

        </Fragment >
    );
};
export default withRouter(MenuHamburguesaInspectorDeCampo)
